import './CodeBlock.scss';

import React, { FunctionComponent } from 'react';

type Props = {
  id: string;
  ariaLabel: string;
  dataQa?: string;
  children: React.ReactNode;
};

const CodeBlock: FunctionComponent<Props> = ({
  id,
  ariaLabel,
  dataQa,
  children,
}) => {
  return (
    <div
      id={id}
      aria-label={ariaLabel}
      className="givingCheckout-codeblock"
      data-qa={dataQa}
    >
      {children}
    </div>
  );
};

export default CodeBlock;
